// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UiycPVZYlcAd1N {\n  position: absolute;\n  height: 64px;\n  width: 64px;\n  transition: transform 85ms ease-in, opacity 85ms ease-in;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.sgeKdlj4MKw599 {\n  height: 64px;\n  width: 64px;\n  color: transparent;\n  border: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": "UiycPVZYlcAd1N",
	"stickerImage": "sgeKdlj4MKw599"
};
export default ___CSS_LOADER_EXPORT___;
